module.exports = __webpack_public_path__ + "static/media/000001.8dca294b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/000001.mp3
// module id = 370
// module chunks = 0